import { NgModule, ModuleWithProviders } from '@angular/core'
import { CommonModule } from '@angular/common'
import { IcosTag } from './tag'


@NgModule({
  declarations: [IcosTag],
  exports: [IcosTag],
  imports: [CommonModule],
  entryComponents: [IcosTag],
})
export class IcosTagsModule {
  static forRoot(): ModuleWithProviders {
    return { ngModule: IcosTagsModule, providers: [] }
  }
}
